import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** B2BCLOUD-4977: Фича для использования темы paradigmTech */
export const isThemeParadigmTech = isFeature('theme-paradigm-tech');
